import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { InvestigationFormRepository } from '../../../infrastructure/repositories/investigation-form.repository';
import { FieldDefinitionLibraryResponseDto } from '../../../infrastructure/dtos/field-definition-library-response.dto';

@Injectable({ providedIn: 'root' })
export class GetFieldDefinitionsUseCase {
  private readonly _repository = inject(InvestigationFormRepository);

  public execute(): Observable<FieldDefinitionLibraryResponseDto> {
    return this._repository.getFieldDefinitions();
  }
}
